import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface Phone {
  key1: string,
  key2: string,
  key3: string,
  key4: string,
  key5: string,
  key6: string,
  key7: string,
  key8: string,
  key9: string,
  key10: string,
  payload: string
}

const initialState: Phone = {
  key1: '',
  key2: '',
  key3: '',
  key4: '',
  key5: '',
  key6: '',
  key7: '',
  key8: '',
  key9: '',
  key10: '',
  payload: ''
};

export const phoneSlice = createSlice({
  name: 'phone',

  initialState,

  reducers: {
    setPhone(state, action: PayloadAction<Phone>) {
      state.key1 = action.payload.key1;
      state.key2 = action.payload.key2;
      state.key3 = action.payload.key3;
      state.key4 = action.payload.key4;
      state.key5 = action.payload.key5;
      state.key6 = action.payload.key6;
      state.key7 = action.payload.key7;
      state.key8 = action.payload.key8;
      state.key9 = action.payload.key9;
      state.key10 = action.payload.key10;
      state.payload =  state.key1 + state.key2 +  state.key3  + state.key4 + state.key5 + state.key6 +  state.key7  + state.key8 + state.key9 + state.key10
    },
  },
});

export const phoneActions = phoneSlice.actions;
export type PhoneSlice = {
  [phoneSlice.name]: ReturnType<typeof phoneSlice['reducer']>
};